import { render, staticRenderFns } from "./SubscriberItemList.vue?vue&type=template&id=c4446804&scoped=true"
import script from "./SubscriberItemList.vue?vue&type=script&lang=ts"
export * from "./SubscriberItemList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4446804",
  null
  
)

export default component.exports